/* comparison-table (home). Bara de derulare custom pentru tabelul care se lățește pe
   mobil (drag pe thumb + sincronizare cu scrollul), portată din
   sursa de referință în idiomul DL.use(). Idempotent (data-bound).
   theme.js (care definește window.DL) e încărcat ultimul în <body>; acest script (în interiorul
   secțiunii, deci mai sus în document) e tot "defer", așa că rulează ÎNAINTE de theme.js — DL nu
   există încă la acel moment. Scripturile "defer" garantează totuși că toate rulează, în ordine,
   înainte de DOMContentLoaded, deci înregistrarea se face pe DOMContentLoaded când DL nu e deja
   disponibil (imediat altfel, ex. la o re-rulare din theme editor). */
(function () {
  'use strict';

  function register() {
    DL.use(function (root) {
      root.querySelectorAll('[data-dl-vs-wrap]:not([data-bound])').forEach(function (wrap) {
        wrap.dataset.bound = '1';
        var scope = wrap.closest('[data-section-type="comparison-table"]') || document;
        var bar = scope.querySelector('[data-dl-vs-scrollbar]');
        var track = scope.querySelector('[data-dl-vs-track]');
        var thumb = scope.querySelector('[data-dl-vs-thumb]');
        if (!bar || !track || !thumb) return;

        function update() {
          var trackW = track.clientWidth;
          var visible = wrap.clientWidth;
          var total = wrap.scrollWidth;
          if (total <= visible + 1) {
            bar.setAttribute('aria-hidden', 'true');
            return;
          }
          bar.removeAttribute('aria-hidden');
          var ratio = visible / total;
          var thumbW = Math.max(56, Math.round(trackW * ratio));
          var maxLeft = trackW - thumbW;
          var pct = wrap.scrollLeft / Math.max(1, total - visible);
          var left = Math.round(maxLeft * Math.max(0, Math.min(1, pct)));
          thumb.style.width = thumbW + 'px';
          thumb.style.transform = 'translateX(' + left + 'px)';
        }

        /* Throttle scroll updates with rAF */
        var rafQueued = false;
        wrap.addEventListener('scroll', function () {
          if (rafQueued) return;
          rafQueued = true;
          requestAnimationFrame(function () { rafQueued = false; update(); });
        });
        window.addEventListener('resize', update);

        /* Drag the thumb to scroll the table */
        var dragging = false;
        var startX = 0;
        var startScroll = 0;
        thumb.addEventListener('pointerdown', function (e) {
          dragging = true;
          startX = e.clientX;
          startScroll = wrap.scrollLeft;
          try { thumb.setPointerCapture(e.pointerId); } catch (_) {}
          e.preventDefault();
        });
        thumb.addEventListener('pointermove', function (e) {
          if (!dragging) return;
          var trackW = track.clientWidth;
          var visible = wrap.clientWidth;
          var total = wrap.scrollWidth;
          var thumbW = thumb.offsetWidth;
          var maxLeft = trackW - thumbW;
          if (maxLeft <= 0) return;
          var dx = e.clientX - startX;
          var dxPct = dx / maxLeft;
          var newScroll = startScroll + dxPct * (total - visible);
          wrap.scrollLeft = Math.max(0, Math.min(total - visible, newScroll));
        });
        function endDrag() { dragging = false; }
        thumb.addEventListener('pointerup', endDrag);
        thumb.addEventListener('pointercancel', endDrag);

        /* Keyboard support */
        thumb.addEventListener('keydown', function (e) {
          var step = wrap.clientWidth * 0.3;
          if (e.key === 'ArrowRight') { wrap.scrollLeft += step; e.preventDefault(); }
          if (e.key === 'ArrowLeft') { wrap.scrollLeft -= step; e.preventDefault(); }
        });

        /* initial */
        update();
      });
    });
  }

  if (window.DL && typeof window.DL.use === 'function') register();
  else document.addEventListener('DOMContentLoaded', register);
})();
